export const onCheckTour = ({ isPriceVariationsInUse, publicData }) => {
  if (!isPriceVariationsInUse) {
    return false;
  } else {
    if (publicData.priceVariants) {
      if (publicData.priceVariants[0].days > 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
